import { HttpErrorResponse } from '@angular/common/http';

export function stringFromError(error: HttpErrorResponse | string): string {
  return typeof error === 'string'
    ? error
    : error?.error?.message || error.message || error.statusText || 'Error making connecting to server';
}
